import {ChannelLogo, HStack, Text, useChannel} from "@hosttools/frontend";
import type {AccountType} from "@hosttools/frontend/models/account";
import type React from "react";
import {memo} from "react";

import PopoverInfo from "@/client/components/PopoverInfo";

interface Props {
    accountType: AccountType;
    size?: "md" | "xl";
}

const ConnectChannelItemLabel: React.FC<Props> = ({accountType, size = "md"}) => {
    const {label} = useChannel(accountType);

    return (
        <HStack className="items-center" space="lg">
            <ChannelLogo
                channel={accountType}
                size={accountType === "ChannelConnector" ? "3xl" : "2xl"}
            />
            {accountType === "HomeAway" ? (
                <HStack className="items-center" space="sm">
                    <Text variant={size}>{`${label}${__IS_CC_ENABLED__ ? " (Direct)" : ""}`}</Text>
                    {__IS_CC_ENABLED__ && (
                        <PopoverInfo
                            icon="info"
                            label={
                                <>
                                    There are two options for connecting to VRBO. The direct
                                    connection can occasionally become disconnected but offers
                                    instant onboarding and doesn&apos;t require a external payment
                                    processing.
                                </>
                            }
                        />
                    )}
                </HStack>
            ) : (
                <Text variant={size}>{label}</Text>
            )}
        </HStack>
    );
};

export default memo(ConnectChannelItemLabel);
